module.exports = __webpack_public_path__ + "static/media/article_image.1175e43f.jpg";